import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BtnTheme } from '../../type/btnTheme.type';
import { FontWeight } from '../../type/fontWeight.type';
import { BtnType } from '../../type/btnType.type';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-stroked-btn',
  templateUrl: './stroked-btn.component.html',
  styleUrls: ['./stroked-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StrokedBtnComponent {
  @Input('color') color: ThemePalette;
  @Input('text') text: string = 'Placeholder';
  @Input('theme') theme: BtnTheme;
  @Input('uppercase') uppercase: boolean = true;
  @Input('disabled') disabled: boolean = false;
  @Input('fontWeight') fontWeight: FontWeight = 400;
  @Input('type') type: BtnType = 'button';
}
